import React from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import CtaPanel from '../components/CtaPanel';
import { teamMembers } from '../data/team';
import { company } from '../data/company';
import './Team.css';

function Team() {
  return (
    <div className="team-page">
      <SEO />

      <PageHero
        breadcrumbs={[
          { name: 'About Us', path: '/about' },
          { name: 'Our Team', path: '/team' },
        ]}
        kicker="Our people"
        bg="/images/bg-team.jpg"
        title="Meet the Team"
        text={`The people behind ${company.name} — dedicated to providing you with quality products, expert advice and exceptional service.`}
      />

      <section className="section section-white">
        <div className="container">
          <figure className="team-group-photo">
            <img
              src="/new_ojanna_front_face.jpg"
              alt={`The ${company.name} team standing together in front of the warehouse and delivery trucks`}
              width="1932"
              height="720"
              loading="lazy"
            />
            <figcaption>The {company.name} team at our premises in Joubert Industria, George</figcaption>
          </figure>
        </div>
      </section>

      <section className="section section-light">
        <div className="container">
          <div className="section-head">
            <span className="pill">Our people</span>
            <h2 className="section-title">The team that makes it happen</h2>
            <p className="section-subtitle">
              From the office to the warehouse floor, every member of our team plays a crucial role in delivering the
              best service to you
            </p>
          </div>

          <div className="team-grid">
            {teamMembers.map((member) => (
              <article className={`team-card${member.highlight ? ' team-card-highlight' : ''}`} key={member.name}>
                <div className="team-card-photo">
                  <img
                    src={member.photo}
                    alt={`${member.name}, ${member.role}`}
                    loading="lazy"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <span className="team-photo-fallback">{member.initials}</span>
                </div>
                <div className="team-card-info">
                  <h3>{member.name}</h3>
                  <span className="team-role">{member.role}</span>
                  <p>{member.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CtaPanel title="Want to work with us?" text="Get in touch — our team is ready to help with your next project." />
    </div>
  );
}

export default Team;
